import { baseTheme } from './DrawerPopupBaseTheme.css';
import { variants, DrawerPopupTheme } from '../DrawerPopupStyles.css';
import { multiVariantStyles } from './DrawerPopupVariants.css';

/*******************
 * Component Theme
 *******************/

const DrawerPopupRedwoodTheme: DrawerPopupTheme = {
  baseTheme,
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { DrawerPopupRedwoodTheme };
